
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site-map-towns/[letter]",
      function () {
        return require("private-next-pages/site-map-towns/[letter].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site-map-towns/[letter]"])
      });
    }
  